import {Injectable} from '@angular/core';
import {LocalStorageService} from './main/local-storage.service';
import {STORAGE_KEY_CE} from './constant-key';

@Injectable()
export class CeStorageService {

    public constructor(private storage: LocalStorageService) {
    }

    /**
     * @param ce
     */
    public set(ce: any): void {
        this.storage.set(STORAGE_KEY_CE, ce);
    }

    /**
     * @returns {any}
     */
    public get(): any {
        return this.storage.get(STORAGE_KEY_CE);
    }

    public remove(): void {
        this.storage.remove(STORAGE_KEY_CE);
    }
}



// WEBPACK FOOTER //
// ./src/shared/services/storage/ce-storage.service.ts